<template>
    <div id="app">
        <el-container class="flextext">

            <home-head></home-head>
            <el-main>

                <div class="shop_main">
                    <template>
                        <div class="block hidden-sm-and-down">
                            <el-carousel height="500px">
                                <el-carousel-item :key="item" v-for="item in zhanbo_list">
                                    <div class="small" style="width: 80%"></div>
                                    <a :href="item.link">
                                        <img alt="" :src="item.img">
                                    </a>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                    </template>
                    <div class="contain_qiangzhiquxiaoimportant">
                        <div class="title">品牌商家</div>
                        <!-- <el-row :gutter="40" class="brand-list">
                            <el-col :xs="12" :sm="6" :md="6" :lg="4" :xl="4" v-for="(brand,index) in brand_list" :key="index" class="item">
                                <a :href="brand.link">
                                    <div class="pinpai-backgd">
                                        <el-image :src="brand.img" fit="cover">
                                            <div slot="error" class="image-slot">
                                                <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 220px">
                                            </div>
                                        </el-image>
                                    </div>
                                </a>
                            </el-col>
                        </el-row> -->
                        <div class="main_pinpai">
                            <!-- <span class="main_pinpai_jiange_biaoti">品牌商家</span> -->
                            <el-row>
                                <!--              <div class="main_pinpai_logo_fenge"></div>-->
                                <el-col class="pinpai-col" :xs="12" :sm="6" :md="6" :lg="4" :xl="4" v-for="(item,index) in brand_list" :key="index">
                                <div class="main_pinpai_logo_neirong">

                                    <!--                    <img class="main_pinpai_logo_neirong_img" style="width: 100%;height: 200px" :src="url+'/storage/'+item.avatar"/>-->
                                    <a :href="item.link" class="" >
                                    <el-image class="main_pinpai_logo_neirong_img"
                                                style="width: 100%;height: 200px;padding:5px"
                                                :src="item.img" fit="fill"
                                    >
                                        <div slot="error" class="image-slot">
                                        <img class="main_pinpai_logo_neirong_img"
                                            style="width: 100%;height: 200px"
                                            src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="">
                                        </div>
                                    </el-image>
                                    </a>

                                </div>
                                <div style="text-align: center;color: #333333;">{{item.name}}</div>
                                </el-col>
                            </el-row>

                        </div>
<!--
                        <el-row :gutter="40">
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                        </el-row>
                        <el-row :gutter="40" style="padding-bottom: 10px">
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                            <el-col :md="6" :sm="12" :xs="12" class="item">
                                <a href="">
                                    <div class="pinpai-backgd">
                                        <img alt="" src="../../../assets/home/logo2.png">
                                    </div>
                                </a>
                            </el-col>
                        </el-row>
                        -->
                        <div class="inner"
                             v-for="(block, block_index) in design_block"
                             :key="block_index" >

                            <div class="left hidden-md-and-down"
                                 :style="{backgroundImage:'url('+ url_pre + '/storage/' + block.pic+')'}" >
                                <div class="cn">{{block.title}}</div>
                                <div style="margin-top: 266px">
                                    <block v-for="(word,word_index) in block.keywords"
                                           v-bind:key="word_index">
                                        <block v-if="word_index % 2 == 0" >
                                            <el-row style="text-align: center" >
                                                <el-col :md="12" :sm="24" :xs="24" class="item">
                                                    <a href="">{{block.keywords[word_index]}}</a>
                                                </el-col>
                                                <el-col v-if="block.keywords[word_index+1]"
                                                        :md="12" :sm="24" :xs="24" class="item">
                                                    <a href="">{{block.keywords[word_index+1]}}</a>
                                                </el-col>
                                            </el-row>
                                        </block>

                                    </block>
                                </div>
                            </div>

                            <div class="shebei" >
                                <el-row :gutter="20">
                                    <el-col :md="6" :sm="12" :xs="12"
                                            v-for="(product,block_item_index) in block.block_item"
                                            :key="block_item_index"
                                            class="shebei-item">
                                        <a :href="'#' + (product.object_type=='fuwu'?'':'/service')
                                        + '/dianpu_details/' + product.object.id">
                                            <div class="backgd" >
                                                <div  style="height:220px;weight:220px;overflow:hidden">
                                                    <el-image style="height:100%;width:100%;object-fit: cover"
                                                              :src="url_pre+'/storage/'+product.object.cover" fit="cover">
                                                        <div slot="error" class="image-slot">
                                                            <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 220px">
                                                        </div>
                                                    </el-image>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <p  class="mall_name"  :title="product.object.title"
                                                            style="width:80%;text-align: center">
                                                        {{product.object.title}}</p>

                                                    <span class="money" style="width: 80%;text-align: center;margin-top: -20px">
                                                        ￥&nbsp;{{product.object.cash?product.object.cash:product.object.price_yugu}}
                                                    </span>
                                                    <p class="mall_gongsi"
                                                       style="width: 80%;text-align: center;color:#A8A297;font-size:12px;"
                                                       :title="product.object.shop_name">
                                                        {{product.object.shop_name}}
                                                    </p>
                                                    <!--                                                    <span class="money" style="margin-top: 20px">￥&nbsp;-->
                                                    <!--                                                      {{product.object.cash == ''?product.object.cash:product.object.price_yugu}}</span>-->
                                                </div>
                                            </div>
                                        </a>
                                    </el-col>

                                </el-row>

                            </div>
                        </div>


                    </div>
                </div>
            </el-main>
            <footerall></footerall>
        </el-container>
    </div>
</template>
<script>
    import home_head from '../../common/home-head_new';
    import footerall from "../../common/footer";
    export default {
        name: 'App',
        data: function () {
            return {
                // is_open: {
                //     sousuo: 1,
                //     lanmu: 1,
                //     information: '',
                // }
                url_pre:'',
                design_block:[],
                brand_list:[],
                zhanbo_list:[],
            }
        },
        components: {
            'home-head': home_head,
            footerall
        },
        methods: {

            init: function () {
                this.url_pre = window.config.api_url;
                this.get_design_block();
                this.get_brand_list();
                this.get_zhanbotu_list()
            },

            get_brand_list:function( ){
              var t = this;
              var url = window.config.api_url + '/college/banner?position=home_fuwu_pinpai';
              t.axios.get(url).then((res)=>{
                t.brand_list = res.data
                console.log(t.brand_list,11111)
              })
            },

            get_design_block: function () {

                var t = this
                var url = window.config.api_url + '/college/block/shangpin/list' + '?position=fuwuzhida'
                t.axios.get(url).then(res => {

                    t.design_block = res.data;
                    t.design_block.forEach(res => {
                        res.keywords = Array.isArray(res.keywords)
                            ? res.keywords
                            : res.keywords.split(',');
                    })
                })

            },
          get_zhanbotu_list(){
            var t = this;
            var url = window.config.api_url + '/college/banner?position=home_fuwu';
            t.axios.get(url).then((res) => {
              t.zhanbo_list = res.data
              console.log(t.zhanbo_list, 1111)
            })
          }

        },
        created() {
            this.init();
            // this.information = this.$store.state.information
        }
    }
</script>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
    //@head_text : Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    @import "../../../assets/css/home_services";
    .flextext{
        display: flex;
        flex-direction: column;
        flex: 1;
        flex-basis: auto;
        box-sizing: border-box;
        min-width: 0;
    }

    .mall_name{
        text-align: center;
        height:36px;
        overflow: hidden;
        font-size:10px;
        margin-top:1px;
        width: 90%;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-family: Source Han Sans CN;
        font-weight: bold;
    }
    .mall_gongsi{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

    }
</style>